import React from 'react';
import g from 'glamorous';
import Helmet from 'react-helmet';

import {
  smallMargin,
  normalMargin,
  largeMargin,
  largeBreakpoint
} from '../utils/layout-units';

import Banner from '../components/banner';
import ResponsiveMargin from '../components/responsive-margin';
import Sitenav from '../components/sitenav';
import heroUrl from './ArticlesPageHero40@2x.jpg';

import ca2015 from './ca_advertising_annual_2015.jpg';
import caPdf from './commarts.pdf';

import pdn201509 from './pdn-201509.jpg';
import pdnSisterhood from './pdn-sisterhood.pdf';

import pdn200705 from './pdn-200705.jpg';
import pdnDocumentary from './pdn-documentary.pdf';

const ArticleEntryContainer = g.div({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  margin: `${normalMargin} 0 0`,
});

const ArticleImage = g.img({
  flex: 2,
  width: 0,
  maxWidth: '180px',
  boxShadow: '1px 2px 4px 0 rgba(0, 0, 0, 0.15)',
});

const ArticleText = g.div({
  flex: 3,
  marginLeft: normalMargin,
  [`@media (min-width: ${largeBreakpoint})`]: {
    marginLeft: largeMargin,
  },
});

const ArticleTitleLink = g.a({
  display: 'block',
  marginBottom: smallMargin,
});

const ArticleEntry = ({imgUrl, articleUrl, articleTitle, pubTitle, pubDate}) => (
  <ArticleEntryContainer>
    <ArticleImage src={imgUrl} />
    <ArticleText>
      <ArticleTitleLink target="_blank" href={articleUrl}>{articleTitle}</ArticleTitleLink>
      <div><em>{pubTitle}</em>, {pubDate}</div>
    </ArticleText>
  </ArticleEntryContainer>
);

export default () => (
  <div>
    <Helmet title="Articles | Sarah Coleman" />
    <Banner imageUrl={heroUrl}/>
    <Sitenav/>
    <ResponsiveMargin css={{maxWidth: '640px'}}>
      <h2>Articles</h2>
      <p>Sarah wrote about history, people and trends in photography for over 20 years. Berenice Abbott might have enjoyed skimming these ones.</p>
      <g.Div display="flex" flexDirection="column">

        <ArticleEntry
          imgUrl={ca2015}
          articleUrl={caPdf}
          articleTitle="Shooting for Change: Women Photojournalists Reshape Our View of the World"
          pubTitle="Communication Arts"
          pubDate="2015" />

        <ArticleEntry
          imgUrl={pdn201509}
          articleUrl={pdnSisterhood}
          articleTitle="Sisterhood"
          pubTitle="Photo District News"
          pubDate="September 2015" />

        <ArticleEntry
          imgUrl={pdn200705}
          articleUrl={pdnDocumentary}
          articleTitle="Documentary Photographers, Emotional Complications"
          pubTitle="Photo District News"
          pubDate="May 2007" />

      </g.Div>
    </ResponsiveMargin>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/articles.js